module.exports = __webpack_public_path__ + "img/features_pic06.ac00b1b8.png";